// Renders whatever it is given: a string, a VNode, an array of VNodes, or the
// result of a config render-callback (config.primary/secondary/renderInstance,
// the custom row/card/tile renderers). React let those return JSX or text
// interchangeably; this is the Vue equivalent render sink.
export const RenderNode = {
  name: 'RenderNode',
  props: {
    node: { default: null },
  },
  setup(props) {
    return () => props.node
  },
}

export default RenderNode
